import(/* webpackMode: "eager" */ "/opt/easydrive/src/app/not-found.tsx");
